import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { AboutEcosystemImage, NumberOfServiceUsers, PageAboutEcosystemProps } from 'client/bundles/types';

import Breadcrumbs from 'client/components/breadcrumbs';
import SectionShiftTitle from 'client/components/section-shift-title';
import WideStripe from 'client/components/wide-stripe';
import LangContext from 'client/utils/lang-context';

import ActiveUsersOfServices from './service-card';

import './index.css';

const b = cn('about-ecosystem');
const bPageTitle = cn('page-title');
const bPageText = cn('page-text');

interface Props {
    ecosystemData?: PageAboutEcosystemProps;
}

class AboutEcosystem extends Component<Props> {
    static contextType = LangContext;

    rendeServices = (images: AboutEcosystemImage) => (
        <picture className={b('picture')}>
            <source
                srcSet={images['scheme-desktop']}
                media="(min-width: 768px)"
                />
            <img src={images['scheme-phone']} className={b('image')} />
        </picture>
    )

    renderActiveUsersOfServices = (numberUsers: NumberOfServiceUsers[]) => (
        <ActiveUsersOfServices services={numberUsers} />
    )

    render() {
        if (!this.props.ecosystemData) {
            return;
        }

        const { title, text, services, images, activeUsers } = this.props.ecosystemData;
        const { dictionary } = this.context;

        return (
            <div className={b()}>
                <Breadcrumbs link="/about" text={dictionary.about} />

                <h1 className={bPageTitle({ type: 'border' })}>{title}</h1>
                <div
                    className={bPageText()}
                    dangerouslySetInnerHTML={{ __html: text }}
                    />

                <WideStripe>
                    <SectionShiftTitle
                        title={services.title}
                        childrenSecond={this.rendeServices(images)}
                        />
                </WideStripe>

                <div className={b('active-users')}>
                    <SectionShiftTitle
                        title={activeUsers.title}
                        childrenSecond={this.renderActiveUsersOfServices(activeUsers.numberUsers)}
                        />
                </div>
            </div>
        );
    }
}

export default AboutEcosystem;
